import { getCSRFToken } from 'www/utils'

function toExternalPage({ domain, url, doctorFio }: {
  doctorFio?: string
  domain: string
  url: string
}) {
  const actionUrl = '/leave/' // URL обработчика

  // Создаем объект FormData
  const formData = new FormData()

  formData.append('csrfmiddlewaretoken', getCSRFToken())
  formData.append('domain', domain)
  formData.append('url', url)

  if (doctorFio) {
    formData.append('doctor_fio', doctorFio)
  }

  // Создаём форму
  const form = document.createElement('form')

  form.method = 'POST'
  form.action = actionUrl
  form.target = '_blank' // Открываем в новой вкладке

  // Добавляем скрытые поля в форму
  formData.forEach((value, key) => {
    const input = document.createElement('input')

    input.type = 'hidden'
    input.name = key
    input.value = value as string
    form.appendChild(input)
  })

  // Отправляем форму (без добавления в DOM)
  document.body.appendChild(form) // Временно добавляем в DOM
  form.submit()
  document.body.removeChild(form) // Удаляем сразу после отправки
}

export default toExternalPage
